export const PROVIDER_TRIPADD = 'TRIPADD'
export const TRIPADD_VAS_TYPES = [
    'BAGGAGE_INSURANCE',
    'CARBON_OFFSET',
    'TOURS',
    'ACTIVITIES',
    'SIGHTSEEING',
    'EVENTS',
    'FLIGHT_CLAIM',
    'LUGGAGE_PROTECTION',
    'AIRPORT_LOUNGES',
    'FLIGHT_DELAY_PROTECTION',
    'MEET_AND_GREET',
    'ONLINE_MAGAZINES',
    'FLIGHT_NOTIFICATIONS',
    'WEATHER_NOTIFICATIONS',
    'AIRPORT_PARKING',
    'CONCIERGE',
    'AIRPORT_TRANSFER',
    'ESIM',
    'AUTO_CHECKIN',
    'MUSEUMS',
    'EXCURSIONS',
    'OUTDOORS',
    'NIGHT_LIFE',
    'RESTAURANTS',
    'OTHER',
    'TRIPADD_PROTECTION',
    'TRIP_PROTECTION',
    'VISA',
    'FAST_TRACK',
    'VIP_SERVICE',
    'TRAVEL_OUTFIT',
    'VPN',
    'ONBOARD_WIFI'
]

export const SHOW_TRIP_ADD = true
